/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: cjy
 * @Date: 2023-07-22 15:52:44
 * @LastEditors: cjy
 * @LastEditTime: 2024-04-01 19:20:52
 */
import dsBridge from 'dsbridge';
import unionDsBridge from './unionDsBridge';
// 防止页面出现报错信息，先在window挂上相关方法
window.openNotificationBack = () => {};
window.openCalendarAuthorizedCallBack = () => {};
window.commonCallBack = () => {};
let jsBridge = {
  APPChannelName: 'ddq_app',
};
if (dsBridge.hasNativeMethod('getUserToken')) { // 新交互
  jsBridge = {
    ...jsBridge,
    ...unionDsBridge,
  };
} else {
  jsBridge = {
    ...jsBridge,
    platform: window.Android || window, // 平台变量（用于调用原生程序定义的方法）
    bridge(params, isSys, type) {
      params[1] = params[1] || '';
      if (!(window.Android && type === 'window') && typeof params[1] !== 'string') {
        params[1] = JSON.stringify(params[1]);
      }
      if (window.Android && type === 'window') {
        return this.platform[params[0]](...params[1]);
      } else if (window.Android && type === 'ocModel') {
        return this.platform && this.platform.appHander && this.platform.appHander(params);
      } else { // ios
        return dsBridge.call(isSys ? 'methonNameSys' : 'methonNameAnSys', params);
      }
    },
    newBridge(params, isSys) {
      if (!window.navigator.userAgent.includes('ddcash')) {
        return;
      }
      if (this.platform === window.Android) {
        return this.platform[params[0]] && this.platform[params[0]](params[1], params[2] || '', params[3] || '');
      } else {
        return dsBridge.call(isSys ? 'methonNameSys' : 'methonNameAnSys', params);
      }
    },
    // 打开webview不会关闭之前的
    startNewWebViewPage(url) {
      this.bridge(['entranceJumpPage', [url], '', ''], false, 'window');
    },
    // 获取appToken
    getAppToken(params) { // callBack 为路由钩子中的next
      return new Promise((resolved) => {
        window.getTokenSuccess = (token) => {
          resolved(token);
        };
        this.bridge(['getToken', params, 'getTokenSuccess', ''], false, 'ocModel');
      });
    },
    getRegisterId(callBack, param = { isEncryption: 0 }) {
      window.getRegisterIdCallBack = callBack;
      return this.newBridge(['getRegisterId', JSON.stringify(param), 'getRegisterIdCallBack', '']);
    },
    setNavRightBtn(param = [{}], callBack) {
      window.newSetRightBtnCallBack = callBack;
      return this.newBridge(['newSetRightBtn', JSON.stringify({
        imgUrl: param[0].oldImage,
      }), 'newSetRightBtnCallBack', '']);
    },
    showNavSuperposedView(param = [], callBack) {
      window.showNavSuperposedViewCallBack = callBack;
      return this.newBridge(['showNavSuperposedView', JSON.stringify(param), 'showNavSuperposedViewCallBack', '']);
    },
    setWebpageSettingInfo(params = {}) {
      const {
        isIntercept = false, isUpload = false,
      } = params;

      window.setWebpageSettingInfoCallBack = (() => { });
      this.newBridge(['setWebpageSettingInfo', JSON.stringify({
        // pageName, 无需设置页面名称，如果是被iframe嵌入沿用被嵌入页面名称，如果是新大概页面，pageName等于modelName(可以通过modelName来区分页面)
        modelName: params.title,
        isIntercept,
        isUpload,
        interceptDesc: '合同涉及敏感信息，为了您的信息安全，请联系客服获取',
      }), 'setWebpageSettingInfoCallBack', '']);
    },
    // 通知app是否需要显示app头部左边按钮
    hideNavRightBtn() {
      this.bridge(['isShowNaviRight', JSON.stringify({ isShow: '0' }), '', ''], false, 'ocModel');
    },
    getLoginMobile() {},
    /**
     * 获取app渠道
     */
    getAppChannel() {},
  };
}
export default jsBridge;
